import React from 'react'
import { graphql, useStaticQuery } from 'gatsby';
import BackgroundImage from 'gatsby-background-image';

const ImgReveal = ({children}) => {

  const data = useStaticQuery(graphql`
      query {
        placeholderImage: file( relativePath: { eq: "blockreveal.jpg" }) {
          childImageSharp {
            fluid(maxWidth: 800) {
              ...GatsbyImageSharpFluid
            }
          }
        }
    }
  `)

  return (
      <BackgroundImage className="img-reveal" Tag="div" fluid={data.placeholderImage.childImageSharp.fluid} fadeIn="soft">
            {
              children
            }
      </BackgroundImage>

  )
}

export default ImgReveal
